import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { GetUserInvitationsResponse } from '../../../../typings/api';

function fetchUserInvitations() {
  return get<GetUserInvitationsResponse>('/api/user-invitations');
}

//  Exported because after creating/deleting an invitation, we need to invalidate this query.
export const userInvitationsQueryKey: QueryKey = ['user-invitations'];

/**
 * Get a list of active user invitations.
 *
 * @param shouldFetch If the request should be made
 */
export default function useUserInvitations(shouldFetch: boolean) {
  return useQuery<GetUserInvitationsResponse>({
    queryKey: userInvitationsQueryKey,
    queryFn: fetchUserInvitations,
    enabled: shouldFetch,
  });
}
